<template>
  <div class="topBar">
    <div class="title">{{ title }}</div>
    <div class="balance" v-if="(title === 'Home' || title === 'Training')&&userInfo" @click="goto('wallet')"><span
        class="val">{{
        separateThousandInteger(userInfo.userBalance.availableBalance)
      }}</span><span>{{ $t('lang.account.currencyType') }}</span>
    </div>
  </div>
</template>

<script>
import {separateThousandInteger} from '@/utils'

export default {
  name: 'TopBar',
  props: ['title'],
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  mounted () {
  },
  methods: {
    separateThousandInteger,
    goto (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style lang="less" scoped>
.topBar {
  position: fixed;
  top: 0;
  width: 100vw;
  height: calc(60vw / 3.6);
  background: var(--container);
  z-index: 99999;

  .title {
    position: relative;
    color: var(--blackFont);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-weight: 600;
    font-size: calc(17vw / 3.6);
    line-height: calc(22vw / 3.6);
    letter-spacing: -0.01em;
  }

  .balance {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: calc(32vw / 3.6);
    width: max-content;
    height: calc(30vw / 3.6);
    line-height: calc(30vw / 3.6);
    background: var(--white);
    border: calc(1vw / 3.6) solid var(--border1);
    border-radius: calc(9999vw / 3.6);
    padding: 0 calc(11vw / 3.6);
    text-align: right;
    font-weight: 600;
    font-size: calc(11vw / 3.6);
    letter-spacing: 0.01em;
    text-transform: uppercase;
    color: #434655;
    display: flex;
    justify-content: center;

    .val {
      font-family: 'Hanken Grotesk';
      font-weight: 700;
      display: flex;
      align-items: center;
      color: var(--blackFont);
      margin-right: calc(6vw / 3.6);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar/index.vue